import { ProductStatus, UserContentStatus } from "../types/typescript-axios";

export const userContentStatusToString = (status: UserContentStatus) =>
  status === ProductStatus.NUMBER_1 ? '公開' :
    status === ProductStatus.NUMBER_2 ? '非公開'
      : '下書き'
